import styled from 'styled-components';
import {
    PEARL_CONNECT_ACCENT,
    PEARL_CONNECT_FIELD_RADIUS,
    PEARL_CONNECT_FIELD_STROKE,
} from 'vendor/styles/pearlConnectFormUiOverrides';

const PEARL_CONNECT_LINK = '#315454';

export const VerifyEmailModalShell = styled.div`
    box-sizing: border-box;
    width: 100%;
    min-height: 240px;
    padding: 16px;
    border: 1px solid ${PEARL_CONNECT_FIELD_STROKE};
    border-radius: 12px;
    background: #fff;
`;

export const CodeFieldColumn = styled.div`
    width: 100%;
    max-width: ${({ $constrain }) => ($constrain ? '353px' : 'none')};
`;

export const VerifyTitle = styled.h2`
    margin: 0 0 8px;
    color: #000000;
    font-family: 'Objektiv Mk2', sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    text-transform: none;
`;

export const VerifyDescription = styled.p`
    margin: 0 0 20px;
    color: #464646;
    font-size: 14px;
    line-height: 24px;
`;

export const FieldLabel = styled.label`
    display: block;
    margin-bottom: 8px;
    color: #464646;
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
`;

export const CodeInputWrap = styled.div`
    border-radius: ${PEARL_CONNECT_FIELD_RADIUS};
    box-shadow: inset 0 0 0 1px ${PEARL_CONNECT_FIELD_STROKE};
    padding: 12px 16px;
    margin-bottom: ${({ $hasError }) => ($hasError ? '8px' : '12px')};

    &:focus-within {
        box-shadow: inset 0 0 0 1px ${PEARL_CONNECT_ACCENT};
    }
`;

export const CodeInput = styled.input`
    width: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    line-height: 24px;
    color: #040404;
    background: transparent;

    &::placeholder {
        color: #9e9e9e;
    }
`;

export const ErrorText = styled.div`
    color: #de1717;
    font-size: 14px;
    margin-bottom: 12px;
`;

export const HintText = styled.p`
    margin: 0 0 12px;
    color: #717777;
    font-size: 12px;
    line-height: 18px;
`;

export const ActionsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    margin-top: 8px;
`;

export const VerifyButtonWrap = styled.div`
    button {
        border-radius: ${PEARL_CONNECT_FIELD_RADIUS} !important;
        background-color: ${PEARL_CONNECT_ACCENT} !important;
        border-color: ${PEARL_CONNECT_ACCENT} !important;
        color: #fff !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        line-height: 20px !important;
        padding: 12px 24px !important;
        min-height: 44px;
    }

    button:hover:not(:disabled) {
        background-color: #234a4c !important;
        border-color: #234a4c !important;
    }

    button:disabled {
        opacity: 0.5;
    }
`;

export const ResendButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-family: 'Objektiv Mk2 Bold', 'Objektiv Mk2', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${(props) => (props.$cooldown ? '#717777' : PEARL_CONNECT_LINK)};
    text-decoration: none;

    &:disabled {
        cursor: not-allowed;
        color: #717777;
    }
`;

export const MobilePageRoot = styled.div`
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
`;
